import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useSearchParams } from 'react-router-dom';
import { CommentBubble1 } from './CommentBubble1';
import { AddEditComment1 } from './AddEditComment1';

export function CommentsTab() {
  const [searchParams] = useSearchParams();
  const objectiveShortId = searchParams.get('objectiveId') ?? undefined;

  const objective = useSelector((state: RootState) =>
    state.map3Data.objectives.find((obj) => obj.shortId === objectiveShortId),
  );

  if (!objective) return null;

  return (
    <div>
      <div className="bg-white pt-4">
        <div>
          <div className="-my-10">
            {objective.comments.map((comment, commentIdx) => (
              <CommentBubble1
                key={comment.uuid}
                commentUuid={comment.uuid}
                showTopBorder={commentIdx !== 0}
                parentObjectiveUuid={objective.uuid}
              />
            ))}
          </div>
        </div>
      </div>
      <AddEditComment1 objectiveUuid={objective.uuid} forIntervalEnding={''} />
    </div>
  );
}
